export const healthServicesCacheKeys = {
  allHealthServices: (queryParams: { search_name?: string } = {}) => [
    'occupational_health_center',
    queryParams
  ]
}
